module.exports = require('./helpers/bundle-url').getBundleURL('89Ico') + "logo.c51670a8.svg";